import { useZorni } from "./useZorni";

export const useRequireAuth = () => {
  const { isAuthenticated, keycloak } = useZorni();

  /**
   * Vérifie l'authentification avant d'exécuter une action
   * @param {Function} action - Fonction à exécuter si connecté
   */
  const requireAuth = async (action) => {
    if (isAuthenticated) {
      // L'utilisateur est connecté, exécute l'action
      await action();
    } else {
      // Sinon redirige vers Keycloak login
      keycloak.login({
        redirectUri: window.location.href, // revient à la page actuelle après login
      });
    }
  };

  return requireAuth;
};
